/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { MatiereAQuotaDto } from '../models/matiere-a-quota-dto';


/**
 * Fonctions de gestion des matières à quota
 */
@Injectable({
  providedIn: 'root',
})
export class MatieresAQuotaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation matiereAQuotaGetList
   */
  static readonly MatiereAQuotaGetListPath = '/api/matiere-a-quota/list';

  /**
   * Renvoie la liste des matières à quota.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<MatiereAQuotaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MatiereAQuotaDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des matières à quota.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetList(params?: {
  }): Observable<Array<MatiereAQuotaDto>> {

    return this.matiereAQuotaGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MatiereAQuotaDto>>) => r.body as Array<MatiereAQuotaDto>)
    );
  }

  /**
   * Path part for operation matiereAQuotaGetListBase
   */
  static readonly MatiereAQuotaGetListBasePath = '/api/matiere-a-quota/listBase';

  /**
   * Renvoie la liste des matières à quota de base.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaGetListBase()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetListBase$Response(params?: {
  }): Observable<StrictHttpResponse<Array<MatiereAQuotaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaGetListBasePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MatiereAQuotaDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des matières à quota de base.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaGetListBase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetListBase(params?: {
  }): Observable<Array<MatiereAQuotaDto>> {

    return this.matiereAQuotaGetListBase$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MatiereAQuotaDto>>) => r.body as Array<MatiereAQuotaDto>)
    );
  }

  /**
   * Path part for operation matiereAQuotaGet
   */
  static readonly MatiereAQuotaGetPath = '/api/matiere-a-quota/{id}';

  /**
   * Renvoie la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGet$Response(params: {

    /**
     * Identifiant de la matière à quota
     */
    id: number;
  }): Observable<StrictHttpResponse<MatiereAQuotaDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereAQuotaDto>;
      })
    );
  }

  /**
   * Renvoie la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGet(params: {

    /**
     * Identifiant de la matière à quota
     */
    id: number;
  }): Observable<MatiereAQuotaDto> {

    return this.matiereAQuotaGet$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereAQuotaDto>) => r.body as MatiereAQuotaDto)
    );
  }

  /**
   * Path part for operation matiereAQuotaPut
   */
  static readonly MatiereAQuotaPutPath = '/api/matiere-a-quota/{id}';

  /**
   * Met à jour la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaPut$Response(params: {

    /**
     * Identifiant de la matière à quota à mettre à jour
     */
    id: number;

    /**
     * Matière à quota
     */
    body: MatiereAQuotaDto
  }): Observable<StrictHttpResponse<MatiereAQuotaDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereAQuotaDto>;
      })
    );
  }

  /**
   * Met à jour la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaPut(params: {

    /**
     * Identifiant de la matière à quota à mettre à jour
     */
    id: number;

    /**
     * Matière à quota
     */
    body: MatiereAQuotaDto
  }): Observable<MatiereAQuotaDto> {

    return this.matiereAQuotaPut$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereAQuotaDto>) => r.body as MatiereAQuotaDto)
    );
  }

  /**
   * Path part for operation matiereAQuotaDelete
   */
  static readonly MatiereAQuotaDeletePath = '/api/matiere-a-quota/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.matiereAQuotaDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation matiereAQuotaPost
   */
  static readonly MatiereAQuotaPostPath = '/api/matiere-a-quota';

  /**
   * Crée la matière à quota.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaPost$Response(params: {

    /**
     * Matière à quota
     */
    body: MatiereAQuotaDto
  }): Observable<StrictHttpResponse<MatiereAQuotaDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereAQuotaDto>;
      })
    );
  }

  /**
   * Crée la matière à quota.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaPost(params: {

    /**
     * Matière à quota
     */
    body: MatiereAQuotaDto
  }): Observable<MatiereAQuotaDto> {

    return this.matiereAQuotaPost$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereAQuotaDto>) => r.body as MatiereAQuotaDto)
    );
  }

  /**
   * Path part for operation matiereAQuotaDesactivate
   */
  static readonly MatiereAQuotaDesactivatePath = '/api/matiere-a-quota/{id}/desactivate';

  /**
   * Désactive la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaDesactivate$Response(params: {

    /**
     * Identifiant de la matière à quota à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereAQuotaDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive la matière à quota spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaDesactivate(params: {

    /**
     * Identifiant de la matière à quota à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereAQuotaDto
  }): Observable<number> {

    return this.matiereAQuotaDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation matiereAQuotaGetListActifs
   */
  static readonly MatiereAQuotaGetListActifsPath = '/api/matiere-a-quota/list-actifs';

  /**
   * Renvoie la liste des matières à quota actives.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<MatiereAQuotaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MatiereAQuotaDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des matières à quota actives.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereAQuotaGetListActifs(params?: {
  }): Observable<Array<MatiereAQuotaDto>> {

    return this.matiereAQuotaGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MatiereAQuotaDto>>) => r.body as Array<MatiereAQuotaDto>)
    );
  }

  /**
   * Path part for operation matiereAQuotaLoadList
   */
  static readonly MatiereAQuotaLoadListPath = '/api/matiere-a-quota/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereAQuotaLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresAQuotaService.MatiereAQuotaLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereAQuotaLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereAQuotaLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.matiereAQuotaLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
